import {nonNullable} from '@stencil/type-guards';

const allFirstLevelObjectKeysAreNonNullable = (object: object) => {
  return Object.keys(object).every(key => nonNullable(object[key]));
};

export default allFirstLevelObjectKeysAreNonNullable;
